import { render, staticRenderFns } from "./SlideGallery.vue?vue&type=template&id=159b6e2c&scoped=true&"
import script from "./SlideGallery.vue?vue&type=script&lang=js&"
export * from "./SlideGallery.vue?vue&type=script&lang=js&"
import style0 from "./SlideGallery.vue?vue&type=style&index=0&id=159b6e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b6e2c",
  null
  
)

export default component.exports